import { postData } from '../../../utils/fetch-api-util';

export interface SetVisibleTypeParams {
  token: string;
}

interface SuccessResponse {
  success: boolean;
}

export const fcmSubscribeRepository = async (url: string, payload: SetVisibleTypeParams): Promise<void> => {
  await postData<SetVisibleTypeParams, SuccessResponse>(url, payload);
};

export const fcmUnSubscribeRepository = async (url: string): Promise<void> => {
  await postData<any, SuccessResponse>(url, null);
};
